import { render, staticRenderFns } from "./DepartmentBasicInfoForm.vue?vue&type=template&id=8726003c&"
import script from "./DepartmentBasicInfoForm.vue?vue&type=script&lang=js&"
export * from "./DepartmentBasicInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DepartmentBasicInfoForm.vue"
export default component.exports